import React from 'react';
import styled from 'styled-components';
import mousePic1 from './images/mousePic1.jpg';
import mousePic2 from './images/mousePic2.jpg';
import mousePic3 from './images/mousePic3.jpg';
import mousePic4 from './images/mousePic4.jpg';

const MouseMosaicBannerStyles = styled.section`
  display: flex;
  justify-content: center;
  max-height: 51.25rem;

  img {
    flex: 1;
    width: 25%;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    max-height: 88vh;
  }
`;

export default function MouseMosaicBanner() {
  return (
    <MouseMosaicBannerStyles>
      <img
        alt="silver mouse"
        src={mousePic1}
        loading="lazy"
        heihg="820"
        width="360"
      />
      <img
        alt="black mouse"
        src={mousePic2}
        loading="lazy"
        heihg="820"
        width="360"
      />
      <img
        alt="white mouse"
        src={mousePic3}
        loading="lazy"
        heihg="820"
        width="360"
      />
      <img
        alt="red mouse"
        src={mousePic4}
        loading="lazy"
        heihg="820"
        width="360"
      />
    </MouseMosaicBannerStyles>
  );
}
